<template>
  <v-dialog v-model="show" persistent max-width="400px">
    <v-card>
      <v-card-title>
        <span v-if="msg" class="subheading" v-html="$t('vmail.del.title')" />
        <span v-if="bulk" class="subheading" v-html="$t('vmail.del.bulkTitle', { count: bulk.length })" />
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <msg-info v-if="msg" :msg="msg" />
        <span v-if="bulk" v-html="$t('vmail.del.bulkConfirm', { count: bulk.length })" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text v-html="$t('vmail.del.btnCancel')" @click="$emit('delete-cancel')" />
        <v-btn text v-html="$t('vmail.del.btnDel')" @click="submit()" color="red" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MsgInfo from './msg_info'
import { mapGetters } from 'vuex'

export default {
  name: 'voicemail-msg-del',
  components: { MsgInfo },
  computed: {
    ...mapGetters({
      voicemailFilter: 'voicemails/filter'
    }),
    currentFolder () {
      return (this.voicemailFilter?.folder === 'all' ? null : this.voicemailFilter?.folder) || null
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    msg: {
      type: Object,
      required: false
    },
    bulk: {
      type: Array,
      required: false
    }
  },
  methods: {
    submit () {
      this.$emit('delete-confirm')
      if (this.$route?.params?.folder === 'detail') {
        this.$router.push({ name: 'voicemails', params: { folder: this.currentFolder } })
      }
    }
  }
}
</script>

<style scoped>
</style>
